import React from "react";
import { UniProfileWrapper } from "@modules/study/university";
import { UniContact } from "@modules/study/university/uni_contact";
import { excerpt } from "@unisearch/helpers";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";

const Contact = ({
  universityProfileData,
  contactOverviewText,
  country_name,
  university_name,
}) => {
  return (
    <LayoutMain
      footer_with_evaluation
      title={
        universityProfileData
          ? `${universityProfileData?.universityName} - Contact`
          : ""
      }
      metaDescription={
        contactOverviewText
          ? excerpt(contactOverviewText, 500)
          : `You can connect with ${universityProfileData?.universityName} directly through your UniSearch dashboard, or reach out to them through the options below!`
      }
      metaImage={
        universityProfileData?.featureSrc ||
        universityProfileData?.coverphotoLogoSrc
      }
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/study/${country_name}/university/${university_name}/contact`}
    >
      <>
        <UniProfileWrapper
          isVideoBanner={false}
          uniProfileData={universityProfileData}
        >
          <UniContact
            uniProfileData={universityProfileData}
            contactOverviewText={contactOverviewText}
          />
        </UniProfileWrapper>
      </>
    </LayoutMain>
  );
};

export default Contact;

export async function getServerSideProps({ params }) {
  const { country_name, university_name } = params;

  let props = {
    universityProfileData: "",
    contactOverviewText: "",
    country_name,
    university_name,
  };

  try {
    const result = await API.get(`/public/university/${university_name}`);
    if (!result.error && result.data) {
      props.universityProfileData = result.data;
    } else {
      return {
        notFound: true,
      };
    }
    await API.get(`/public/university/get-overview/${university_name}`).then(
      (resp) => {
        if (!resp.error && resp.data) {
          props.contactOverviewText = resp.data.contactOverview;
        }
      }
    );
    return {
      props,
    };
  } catch (err) {
    return {
      props,
    };
  }
}
